import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@mui/material';
import { PackageHistoryDto } from '../../../api/models/PackageDto';

interface RestoreConfirmationDialogProps {
    open: boolean;
    version: PackageHistoryDto | null;
    onClose: () => void;
    onConfirm: () => void;
}

const RestoreConfirmationDialog: React.FC<RestoreConfirmationDialogProps> = ({
    open,
    version,
    onClose,
    onConfirm
}) => {
    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleString();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm Restore</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to restore this package to the version from{" "}
                    {version && formatDate(version.validFrom)}?
                    This action cannot be undone, but you can restore to other versions later.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="warning" variant="contained">
                    Restore
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RestoreConfirmationDialog;